// controllers/scroll_controller.js
import { Controller } from "@hotwired/stimulus"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.setupPanels()
  }

  setupPanels() {
    const panels = this.panelTargets

    panels.forEach((panel, index) => {
      const nextPanel = panels[index + 1]

      ScrollTrigger.create({
          trigger: panel,
          start: "top top",
          end: nextPanel ? "+=100%" : "top top",
          pin: true,
          pinSpacing: false,
          scrub: true,
          snap: 1 / (panels.length - 1),
      })
    })
  }
}